<template>
   <div id="dashboard_wrapper">
      <div class="card-body">
         <div class="alert alert-success" role="alert" v-if="loading">
            {{ $t("account-page-notif-control.other_settings.success_msg") }}
         </div>
         <h4 class="card-title">
            {{ $t("account-page-notif-control.other_settings.title") }}
         </h4>
         <br />

         <p> {{ $t("account-page-notif-control.other_settings.first_paragraph") }} </p>
         <hr />

         <p> {{ $t("account-page-notif-control.other_settings.second_paragraph") }} </p>

         <!-- display pass switch -->
         <div class="d-flex flex-row mb-4">
            <div> {{ $t("account-page-notif-control.other_settings.switch_btn_label") }} </div>
            <div class="pl-2">
               <toggle-button v-model="display_pass_email.value.visibility"
                  :labels="{ checked: 'On', unchecked: 'Off' }" :value="display_pass_email" :sync="true" />
            </div>
         </div>
         <hr>

         <div>
            <p>
               {{ $t("account-page-notif-control.other_settings.send_completion_email_sentence") }}
            </p>

            <!-- Checkin -->
            <div class="d-flex flex-row">
               <div> {{ $t("account-page-notif-control.other_settings.switch_checkin_toggle_label") }} </div>
               <div class="pl-2">
                  <toggle-button v-model="sendEmailByPMSSettings.send_checkin_email_by_pms.value.enabled"
                     :labels="{ checked: 'On', unchecked: 'Off' }" :value="sendEmailByPMSSettings" :sync="true" />
               </div>
            </div>

            <!-- Checkout -->
            <div class="d-flex flex-row mt-2 mb-4">
               <div> {{ $t("account-page-notif-control.other_settings.switch_checkout_toggle_label") }} </div>
               <div class="pl-2">
                  <toggle-button v-model="sendEmailByPMSSettings.send_checkout_email_by_pms.value.enabled"
                     :labels="{ checked: 'On', unchecked: 'Off' }" :value="sendEmailByPMSSettings" :sync="true" />
               </div>
            </div>

            <!-- by pass send lock -->
            <hr />
            <p> {{ $t("account-page-notif-control.other_settings.send_digital_key_sentence") }} </p>
            <div> {{ $t("account-page-notif-control.other_settings.send_digital_key_note") }} </div>
            <div class="d-flex flex-row mt-3">
               <div> {{ $t("account-page-notif-control.other_settings.switch_not_bypass_send_lock_toggle_label") }} </div>
               <div class="pl-2">
                  <toggle-button v-model="notBypassSendLock.value.enabled"
                     :labels="{ checked: 'On', unchecked: 'Off' }" :value="notBypassSendLock" :sync="true" />
               </div>
            </div>
         </div>

         <!-- form button -->
         <br />
         <div class="row">
            <div class="col-lg-12" align="center">
               <button @click.prevent="
                  $router.push({
                     name: 'checkin-facility-dashboard-notif-control',
                  })" class="btn btn-danger ml-3">
                  {{ $t("account-page-notif-control.other_settings.back_btn") }}
               </button>

               <button @click="$bvModal.show('modal-confirmation')" type="button" class="btn btn-primary ml-3">
                  {{ $t("account-page-notif-control.other_settings.confirm_btn") }}
               </button>
            </div>
         </div>

      </div> <!-- end card body -->

      <confirmation-modal-component @click-handler="submit" />
   </div>
</template>
<script>
import _ from 'lodash';
import ConfirmationModalComponent from "./../../components/confirmation-modal.component";

export default {
   components: {
      ConfirmationModalComponent
   },
   data() {
      return {
         loading: false,
         facility: {},
         display_pass_email: {
            facility_id: 0,
            name: 'display_pass_email',
            value: {
               visibility: true
            }
         },
         sendEmailByPMSSettings: {
            send_checkin_email_by_pms: { value: { enabled: true } },
            send_checkout_email_by_pms: { value: { enabled: true } },
         },
         notBypassSendLock: { value: { enabled: true } }, // DEFAULT - ON: Need to have payment (Paid, PA, PC) when check-in.
         error: false,
         success: false,
      }
   },

   async mounted() {
      this.facility = window._app_facility
      this.initOtherSettings();
   },

   methods: {
      async initOtherSettings() {
         const settingNames = [
            'display_pass_email',
            'send_email_by_pms_settings',
            'not_bypass_send_lock'
         ];
         const otherSettingResults = await this.$lionheart
            .get('/v2/other-facility-settings/list', {
               params: {
                  name: settingNames,
                  facility_id: this.facility.id
               }
            })
            .then(r => r.data.data)
            .catch(e => this.catcher(e));
         this.handleMapOtherSettings(otherSettingResults);

      },
      async submit() {
         this.loading = true;
         const data = {
            facility_id: this.facility.id,
            otherSettingsData: [
               {
                  name: 'display_pass_email',
                  value: { visibility: this.display_pass_email.value.visibility }
               },
               {
                  name: 'send_email_by_pms_settings',
                  value: {
                     send_checkin_email_by_pms: { enabled: this.sendEmailByPMSSettings.send_checkin_email_by_pms.value.enabled },
                     send_checkout_email_by_pms: { enabled: this.sendEmailByPMSSettings.send_checkout_email_by_pms.value.enabled },
                  }
               },
               {
                  name: 'not_bypass_send_lock',
                  value: { enabled: this.notBypassSendLock.value.enabled }
               }
            ]
         }

         const updateOrCreateOtherSettings = await this.$lionheart.post('/v2/other-facility-settings', { ...data })
            .then(r => r.data.data)
            .catch(e => this.catcher(e))

         this.handleMapOtherSettings(updateOrCreateOtherSettings);

         location.href = "#dashboard_wrapper"
         setTimeout(() => {
            this.loading = false
         }, 3000);
      },

      handleMapOtherSettings(response) {
         if (!response) return;

         const hasDisplayPass = response.display_pass_email?.visibility ?? null
         if(hasDisplayPass != null) {
            this.display_pass_email.value.visibility = hasDisplayPass;
         }

         const hasSendCheckinEmailByPMSSettings = response.send_email_by_pms_settings?.send_checkin_email_by_pms?.enabled ?? null
         const hasSendCheckoutEmailByPMSSettings = response.send_email_by_pms_settings?.send_checkout_email_by_pms?.enabled ?? null
         if(hasSendCheckinEmailByPMSSettings != null && hasSendCheckoutEmailByPMSSettings != null) {
            this.sendEmailByPMSSettings.send_checkin_email_by_pms.value.enabled = hasSendCheckinEmailByPMSSettings;
            this.sendEmailByPMSSettings.send_checkout_email_by_pms.value.enabled = hasSendCheckoutEmailByPMSSettings;
         }
         const hasnotByPassSendLock = response.not_bypass_send_lock?.enabled ?? null
         if(hasnotByPassSendLock != null) {
            this.notBypassSendLock.value.enabled = hasnotByPassSendLock;
         }
      },
   }
}
</script>